import React from 'react';
import ReactDOM from "react-dom/client";
import '@agtech/web/styling/css/AgTech/AgTech.css';
import '@agtech/web/styling/css/fontawesome.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './index.css';
import SalesApp from './app/SalesApp';

let rootNode = document.getElementById("root");

if (rootNode) {
  ReactDOM.createRoot(rootNode).render(<SalesApp />);
}